import {PreSelectedParlayStatus} from "../../../constants/PickXEnums";

export const handlePreSelectedParlayChanged = (state, action)=>{
    const index = state.preSelectedParlays.findIndex(p => p.Id === action.payload.PreSelectedParlay.Id);
    if (index !== -1) {
        const preSelectedParlay = state.preSelectedParlays[index];
        action.payload.Changes.forEach(c=>{
            preSelectedParlay[c.Name] = c.newValue;
        });
    }
};
export const handlePreSelectedParlayCreated = (state, action)=>{

};
export const handlePreSelectedParlayDeleted = (state, action)=>{
    const index = state.preSelectedParlays.findIndex(p => p.Id === action.payload.PreSelectedParlayId);
    if (index !== -1) {
        state.preSelectedParlays = state.preSelectedParlays.filter(p => p.Id !== action.payload.PreSelectedParlayId);
    }
};
export const handlePreSelectedParlayExpired = (state, action)=>{
    const index = state.preSelectedParlays.findIndex(p => p.Id === action.payload.PreSelectedParlayId);
    if (index !== -1) {
        state.preSelectedParlays[index].Status = PreSelectedParlayStatus.Expired;
    }
};

export const handlePreSelectedParlayCancelled = (state, action)=>{
    const index = state.preSelectedParlays.findIndex(p => p.Id === action.payload.PreSelectedParlayId);
    if (index !== -1) {
        state.preSelectedParlays[index].Status = PreSelectedParlayStatus.Cancelled;
    }
}